import {Graphics} from "pixi.js";
import {inches, lineRed, lineRedGrey} from "../const";

// perpendicular gap between the diagonal lines of a cut hatch (scene units = mm).
const HATCH_SPACING = 1/8 * inches;

// marks a cut-out region (a door over/undercut, or a frame undercut) with a faint
// red fill, a red 45° diagonal hatch, and a solid red outline. Shared by DoorLeaf
// and StickMaterial so every cut reads the same.
export function drawCutMarker(g: Graphics, x: number, y: number, w: number, h: number) {
    if (w <= 0 || h <= 0) return;

    g.lineStyle(0);
    g.beginFill(lineRedGrey, 0.4);
    g.drawRect(x, y, w, h);
    g.endFill();

    g.lineStyle(1, lineRed, 1);
    drawHatchRect(g, x, y, w, h, HATCH_SPACING);
    g.drawRect(x, y, w, h);
}

// strokes a diagonal (45°, down-right) hatch clipped to a rectangle; the current
// lineStyle is used for the hatch lines. `spacing` is the perpendicular gap
// between adjacent lines.
export function drawHatchRect(g: Graphics, x: number, y: number, w: number, h: number, spacing: number) {
    const x0 = x, x1 = x + w, y0 = y, y1 = y + h;

    // each line is y = x + b; stepping the intercept b by spacing*√2 spaces the
    // lines `spacing` apart perpendicular to their 45° direction.
    const step = spacing * Math.SQRT2;
    const bMin = y0 - x1;
    const bMax = y1 - x0;

    for (let b = bMin; b <= bMax; b += step) {
        // clip the line to the rect: x runs where both x and y=x+b stay in bounds.
        const xa = Math.max(x0, y0 - b);
        const xb = Math.min(x1, y1 - b);
        if (xa > xb) continue;

        g.moveTo(xa, xa + b);
        g.lineTo(xb, xb + b);
    }
}
